import axios from 'axios'
import { API_URL, ONBOARDING_SERVICE_PATH } from '../constants/apiUrl'
import { ConfigurationNames } from '../store/Scenario.store'
import { devLog } from './devLog'

export type residenceProofType = 'energy_bill' | 'telecom_bill' | 'pay_slip'

// Tink product behind the /micropayment flow. Older backends omit the field,
// which means the classic 0,01 EUR micropayment.
export type TinkTransactionType = 'Micropayment' | 'AccountInformation'

export interface ContextData {
  language: string
  changeLanguagePossible?: boolean
  configurationId?: ConfigurationNames
  shouldAskForEmail?: boolean
  shouldAskForPhoneNumber?: boolean
  shouldSelectDocument?: boolean
  askUserForPlaceAndCountryOfBirth?: boolean
  showVideoIdHintsScreen?: boolean
  shouldUploadBankStatement?: boolean
  env?: string
  documentType?: string
  documentUploadUrl?: string
  providerClientId?: string
  bankStatementUpload?: string
  showTransactionCompletedWaitingScreen?: boolean
  flowType?: string
  wizzardSessionKey?: string
  startSessionUrl?: string
  shouldMockSenderHolder?: boolean
  transactionType?: TinkTransactionType
  abTestConfig?: { variant?: string }
  termsAndConditionsPresent?: boolean
  expectedAddress?: {
    city?: string
    street?: string
    postalCode?: string
  }
  isRetryAttempt?: boolean
  previousAttempt?: {
    documentType?: string
    documentFileName?: string
    residenceProofType?: residenceProofType
  }
  isPaySlip?: boolean
  availableResidenceProofTypes?: residenceProofType[]
  forceScrollingBeforeDocumentAccept?: boolean
  cancelSurveyScreenEnabledServiceList?: string[]
  instructionalVideoUrl?: string
  fullName?: string
  showScrollToBottomButton?: boolean
  otpChallengeCodeConfiguration?: {
    charset: 'Alpha' | 'Alphanumeric' | 'Numeric'
    length: number
  }
  acceptUnfairClauses?: boolean
}

export type ContextNames =
  | 'videoId'
  | 'address-verification'
  | 'micropayment-fintec'
  | 'kontomatik'
  | 'onboarding'

const contextUrlMap = {
  onboarding: ONBOARDING_SERVICE_PATH,
  videoId: 'electronic-id',
  'micropayment-fintec': 'micropayment',
  // kontomatik: 'kontomatik',
  'address-verification': 'pixel-speak',
}

export async function getOnboardingContext(
  contextId: ContextNames
): Promise<ContextData | undefined> {
  try {
    const response = await axios.get(
      `${API_URL}/${
        contextUrlMap[contextId as keyof typeof contextUrlMap] || contextId
      }/get-context`,
      {
        withCredentials: true,
      }
    )

    return response.data
  } catch (e) {
    devLog(e)
  }
}
